// extracted by css-extract-rspack-plugin
export default {"bottom-sheet-wrapper":"TooltipCommon-module__bottom-sheet-wrapper--dkJSH","bottomSheetWrapper":"TooltipCommon-module__bottom-sheet-wrapper--dkJSH"};